import { BrowserRouter as Router} from 'react-router-dom'
import { UserRolesProvider } from './contexts/UserRolesContext'
import { Helmet } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify'
import AppRoutes from './AppRoutes'
import { LoadingProvider } from './contexts/LoadingContext';
import LoadingSpinner from './LoadingSpinner';

export default function App() {
  return (
    <>
      <Helmet titleTemplate="Channel Portal - %s" defaultTitle="Channel Portal" />

      <LoadingProvider>
        <LoadingSpinner />
        <UserRolesProvider>
          <Router>
            <AppRoutes />
          </Router>
        </UserRolesProvider>
      </LoadingProvider>
      <ToastContainer />
    </>
  )
}
